import React, {Component} from 'react'
import PropTypes from "prop-types";
import "../../../sass/SmarthomeAppPromoPC.css"

/**
 * Версия Промо
 */
export default class PopupBrowser extends Component {
    state = {
        isHidden: true
    };
    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({ isHidden: false });
        }, 3000);
    }
    render() {
        const bannerClasses = {
            "banner1": 'cameras-banner',
        };

        const bannerClass = bannerClasses['banner' + this.props.popupImageIndex];

        return (
            <div>
                <div className="popup-pc">
                    <input type="button" className="popup-pc__btn-close" hidden={this.state.isHidden} onClick={this.props.closeCallback}/>
                    <div className="popup-pc-blur"></div>
                    <div className={"popup-pc-body " + bannerClass}>
                        {
                            this.props.buttons && this.props.buttons.map((button, key) => {
                                return React.cloneElement(button, {key})
                            })
                        }
                    </div>
                </div>
            </div>

        )
    }
}

PopupBrowser.propTypes = {
    popupImageIndex: PropTypes.any.isRequired,
    buttons: PropTypes.array,
    closeCallback: PropTypes.func
}
